import React from "react";
import AdminLayout from "./AdminLayout";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";

function AdminHome() {
    return (
        <AdminLayout>
            <h2>Welcome to Admin Home</h2>
            <p>Dashboard content goes here.</p>

            <Button as={Link} to="/" variant="primary">
                Go to Webpage
            </Button>

        </AdminLayout>
    );
}

export default AdminHome;
